import api from './api';

const resource = 'Timezone/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

const timezoneApi = { list, getById };

export default timezoneApi;
